import {FC, HTMLAttributes} from 'react';
import {clsx} from 'clsx';
import {useTranslation} from 'react-i18next';

import logoSource from '@/assets/images/logo-beneva.svg';

const Logo: FC<HTMLAttributes<HTMLDivElement>> = ({className, ...props}) => {
  const {t} = useTranslation();

  return (
    <div className={clsx('col-start-2 flex flex-col items-center gap-1', className)} data-testid="logo" {...props}>
      <img src={logoSource} className="h-[25px] w-[108px]" alt="" />

      <div className="text-sm font-bold text-black">{t('components.application-header.logo.title')}</div>
    </div>
  );
};

export default Logo;
